"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductEditorTable = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const row_component_1 = require("./row/row.component");
const generic_1 = require("../../../generic");
const localization_1 = require("../../../localization");
const components_1 = require("..");
const ProductEditorTable = ({ columns, currentPage, getTableRows, isLoading, onPageChange, onRowsPerPageChange, onSort, products, rowsPerPage, sortParams, total = 0, selectedRows = [], checkboxColumnOrder, isExpandable, onSelect, onSelectAll, shouldRowBeHighlighted, onFilterClick, isFilterActive, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const isProductSelected = (0, react_1.useCallback)((row) => !!selectedRows.find(({ id }) => id === row.id), [
        selectedRows,
    ]);
    return (react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(ui_components_1.Table, { columns: columns, handleSelectAllClick: onSelectAll, hasEndButtonsCell: false, rowCount: products.length, selectedRowCount: selectedRows.length, checkboxColumnOrder: checkboxColumnOrder, handleSort: onSort, sortParam: sortParams[0], isFilterActive: isFilterActive, onFilterClick: onFilterClick }, isLoading ? (react_1.default.createElement(material_1.TableRow, null, react_1.default.createElement(material_1.TableCell, { colSpan: columns.length + 1 }, react_1.default.createElement(generic_1.Loading, { isLoading: true })))) : !(products === null || products === void 0 ? void 0 : products.length) ? (react_1.default.createElement(material_1.TableRow, null, react_1.default.createElement(material_1.TableCell, { colSpan: columns.length + 2 }, react_1.default.createElement(components_1.NoResults, null)))) : (products.map((product) => (react_1.default.createElement(row_component_1.ProductEditorTableRow, { key: product.id, getTableRows: getTableRows, shouldRowBeHighlighted: shouldRowBeHighlighted, product: product, isRowChecked: isProductSelected(product), onRowSelect: (event) => onSelect(event, product), isExpandable: isExpandable }))))), react_1.default.createElement(generic_1.TablePagination, { itemsCount: total, pageNumber: currentPage, rowsPerPage: rowsPerPage, onPageChange: onPageChange, onRowsPerPageChange: onRowsPerPageChange, modelType: t({ key: 'PRODUCT_EDITOR_TABLE_ITEMS_NAME' }) })));
};
exports.ProductEditorTable = ProductEditorTable;
exports.default = react_1.default.memo(exports.ProductEditorTable);
